/**
 * Block reasons that a Thalamos admin may override when manually creating a
 * Xero bill. These are guardrail limits, not technical impossibilities.
 */
export const OVERRIDABLE_BLOCK_REASONS = [
    "max_payment_exceeded",
    "max_doctor_requests_per_day",
    "max_patient_requests_per_day",
    "max_other_exceeded",
    "max_mileage_exceeded",
];
//# sourceMappingURL=xero.js.map